export const homeOneData = [
  {
    title: "订单结算",
    className: "c-ff6900 iconfont icon-jiesuan c-home-icon",
    routeName: "orderBalance"
  },
  {
    title: "付款申请",
    className: "c-00bbab iconfont icon-icon-payment c-home-icon",
    routeName: "paymentApply"
  },
  {
    title: "付汇申请",
    className: "c-247be3 iconfont icon-zhangdan c-home-icon",
    routeName: "remittance"
  }
];

export const homeTwoData = [
  {
    title: "付款单",
    className: "c-409EFF iconfont icon-tubiao_fukuandan c-home-icon",
    routeName: "paymentOrder"
  },
  {
    title: "内贸合同",
    className: "c-ff583f iconfont icon-hetong c-home-icon",
    routeName: "orderContract"
  }
];
